import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import studentApi from '../StudentApi';

export default function ActiveVouchersList({ studentId, onSetExam }) {
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchActiveVouchers = async () => {
    setLoading(true);
    try {
      const res = await studentApi.get(`/student-vouchers/${studentId}`);
      if (res.data.success) {
        // const filtered = res.data.data.filter(v =>
        //   (v.student_id === studentId || v.student_id === null) &&
        //   (v.active === 1 || v.status === 'active')
        // );

        const filtered = res.data.data.filter(v =>
          v.student_id === studentId && v.status === 'active'
        );

        setActiveVouchers(filtered);
      } else {
        setActiveVouchers([]);
      }
    } catch (err) {
      console.error(err);
      setActiveVouchers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studentId) fetchActiveVouchers();
  }, [studentId]);

  return (
    <Box sx={{ border: '1px solid #ddd', borderRadius: 1, p: 1, mt: 2 }}>
      {/* Section Title */}


      {/* Loading */}
      {loading && <CircularProgress size={20} />}

      {/* No vouchers */}
       {!loading && activeVouchers.length === 0 && (
        <Typography variant="body2" sx={{ fontSize: '0.75rem', textAlign: 'center', mt: 1 }}>
          No active vouchers available.
        </Typography>
      )}

      {/* Voucher List */}
      {!loading && activeVouchers.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {activeVouchers.map(v => (
            <Box
              key={v.id}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 0.75,
                borderBottom: '1px solid #ddd',
                fontSize: '0.75rem',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.15 }}>
                <Typography sx={{ fontWeight: 'bold', fontSize: '0.78rem' }}>
                  {v.code} ({v.type.toUpperCase()})
                </Typography>
                <Typography sx={{ fontSize: '0.73rem' }}>Exam: {v.exam_name ?? '-'}</Typography>
                <Typography sx={{ fontSize: '0.73rem' }}>Subject: {v.subject_name ?? '-'}</Typography>
                <Typography sx={{ fontSize: '0.73rem' }}>Topic: {v.topic_name ?? '-'}</Typography>
                <Typography sx={{ fontSize: '0.73rem' }}>Usage Limit: {v.usage_limit}</Typography>
              </Box>

              <Button
                variant="contained"
                size="small"
                onClick={() => onSetExam(v)}
                sx={{ ml: 1, minWidth: '65px', fontSize: '0.7rem' }}
              >
                Set Exam
              </Button>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
